import React from 'react';
const facts = [{
  value: '52',
  label: 'Ready-to-run group lessons'
}, {
  value: '3',
  label: 'Lanes in every lesson'
}, {
  value: '30/45/60',
  label: 'Minute versions of every class'
}, {
  value: '20',
  label: 'Coach worksheets'
}];
export function SocialProofBar() {
  return <section className="w-full bg-rink-deep" data-id="element-418" data-mp="25t41p7lcqct9">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-419" data-mp="25uf2qznex6go">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-rink-line bg-rink-line sm:grid-cols-4" data-id="element-420" data-mp="32jmpuc3ojnmp">
          {facts.map(fact => <div key={fact.label} className="bg-rink px-4 py-5 text-center" data-id="element-421" data-mp="2xi756l5ezj4u">
              <div className="font-display font-bold text-3xl sm:text-4xl leading-none text-amber" data-id="element-422" data-mp="2tglkweqjw2km">
                {fact.value}
              </div>
              <div className="mt-2 text-[10px] font-semibold uppercase tracking-widest text-white/60" data-id="element-423" data-mp="1i3svvbp59s89">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}